import { TaxProvider } from '@/models/settings.model';

export const recommendedImageSizes = {};

export const RECOMMENDED_THUMB_FILE_TYPES = 'JPEG, PNG, SVG, WEBP';

export const RECOMMENDED_ICON_FILE_TYPES = 'SVG';

export const taxProviderOptions = [
  { label: TaxProvider.AVA_TAX, value: TaxProvider.AVA_TAX },
  { label: TaxProvider.TAX_CLOUD, value: TaxProvider.TAX_CLOUD },
];
